import { DOCUMENT } from '@angular/common'
import { Inject, Injectable } from '@angular/core'

@Injectable({
  providedIn: 'root'
})
export class GoogleFontsService {
  constructor(@Inject(DOCUMENT) private document: Document) {}

  public useGoogleFont(fontFamilyName: string) {
    if (!fontFamilyName || fontFamilyName.length === 0) {
      return
    }

    console.log(`Setting user defined font family tox ${fontFamilyName}`)
    this.document.body.style.setProperty(
      '--bs-body-font-family',
      `'${fontFamilyName}', 'Open Sans', var(--bs-font-sans-serif)`
    )
  }

  public addGoogleFontLink(fontFamilyName: string) {
    if (!fontFamilyName || fontFamilyName.length === 0) {
      return
    }

    const fontFamilyNameForLinkTag = fontFamilyName.split(' ').join('+')

    const link = this.document.createElement('link')
    link.rel = 'stylesheet'
    link.href = `https://fonts.googleapis.com/css2?family=${fontFamilyNameForLinkTag}:ital,wght@0,400;0,600;0,700;1,400;1,600;1,700&display=swap`
    this.document.head.appendChild(link)
  }
}
